export const unitTypes = [
    { value: 'Metro', label: 'Metro' },
    { value: 'Yarda', label: 'Yarda' },
    { value: 'Vara', label: 'Vara' },
    { value: 'Pie', label: 'Pie' },
    { value: 'Pulgada', label: 'Pulgada' },
    { value: 'Milímetro', label: 'Milímetro' },
    { value: 'Milla cuadrada', label: 'Milla cuadrada' },
    { value: 'Kilómetro cuadrado', label: 'Kilómetro cuadrado' },
    { value: 'Hectárea', label: 'Hectárea' },
    { value: 'Manzana', label: 'Manzana' },
    { value: 'Acre', label: 'Acre' },
    { value: 'Metro cuadrado', label: 'Metro cuadrado' },
    { value: 'Yarda cuadrada', label: 'Yarda cuadrada' },
    { value: 'Vara cuadrada', label: 'Vara cuadrada' },
    { value: 'Pie cuadrado', label: 'Pie cuadrado' },
    { value: 'Pulgada cuadrada', label: 'Pulgada cuadrada' },
    { value: 'Metro cúbico', label: 'Metro cúbico' },
    { value: 'Yarda cúbica', label: 'Yarda cúbica' },
    { value: 'Barril', label: 'Barril' },
    { value: 'Pie cúbico', label: 'Pie cúbico' },
    { value: 'Galón', label: 'Galón' },
    { value: 'Litro', label: 'Litro' },
    { value: 'Botella', label: 'Botella' },
    { value: 'Pulgada cúbica', label: 'Pulgada cúbica' },
    { value: 'Mililitro', label: 'Mililitro' },
    { value: 'Onza fluida', label: 'Onza fluida' },
    { value: 'Tonelada métrica', label: 'Tonelada métrica' },
    { value: 'Tonelada', label: 'Tonelada' },
    { value: 'Quintal métrico', label: 'Quintal métrico' },
    { value: 'Quintal', label: 'Quintal' },
    { value: 'Arroba', label: 'Arroba' },
    { value: 'Kilogramo', label: 'Kilogramo' },
    { value: 'Libra troy', label: 'Libra troy' },
    { value: 'Libra', label: 'Libra' },
    { value: 'Onza troy', label: 'Onza troy' },
    { value: 'Onza', label: 'Onza' },
    { value: 'Gramo', label: 'Gramo' },
    { value: 'Miligramo', label: 'Miligramo' },
    { value: 'Megawatt', label: 'Megawatt' },
    { value: 'Kilowatt', label: 'Kilowatt' },
    { value: 'Watt', label: 'Watt' },
    { value: 'Megavoltio-amperio', label: 'Megavoltio-amperio' },
    { value: 'Kilovoltio-amperio', label: 'Kilovoltio-amperio' },
    { value: 'Voltio-amperio', label: 'Voltio-amperio' },
    { value: 'Gigawatt-hora', label: 'Gigawatt-hora' },
    { value: 'Megawatt-hora', label: 'Megawatt-hora' },
    { value: 'Kilowatt-hora', label: 'Kilowatt-hora' },
    { value: 'Watt-hora', label: 'Watt-hora' },
    { value: 'Kilovoltio', label: 'Kilovoltio' },
    { value: 'Voltio', label: 'Voltio' },
    { value: 'Millar', label: 'Millar' },
    { value: 'Medio millar', label: 'Medio millar' },
    { value: 'Ciento', label: 'Ciento' },
    { value: 'Docena', label: 'Docena' },
    { value: 'Unidad', label: 'Unidad' },
    { value: 'Otra', label: 'Otra' },
];